import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNavSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-200 text-secondary-700 rounded-full text-xs font-medium mb-3">
            分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            探索漫画类型
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            多种分类，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-4 p-5 bg-background-50 rounded-lg hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-secondary-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count} 部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}